<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新增管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>销售发货</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clickSearch" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.projectcode" placeholder="请选择产品" class="select" filterable>
              <el-option
                v-for="item in ProjectNameList" :key="item.Code" :label="item.Name" :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch">查询</el-button>
            <el-button type="primary" @click="clickexcel()">导出Excel</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
            注意：此处是覆盖导入
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border :cell-style="{padding: '0'}" height="440">
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.Sublist" height="150" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center',padding: '0' }">
                <el-table-column prop="Trackingnumber" label="快递号" width="400"></el-table-column>
                <el-table-column prop="Num" label="发货数量" width="200"></el-table-column>
                <el-table-column prop="Createtime" label="发货时间" width="200"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Orderid" label="销售订单合同编号" width="200"></el-table-column>
          <el-table-column prop="CustomerName" label="客户名称" width="300"></el-table-column>
          <el-table-column prop="Projectname" label="产品名称" width="250"></el-table-column>
          <el-table-column prop="Num" label="销售订单数量" width="120"></el-table-column>
          <el-table-column prop="Shichangjia" label="市场销售价" width="120"></el-table-column>
          <el-table-column prop="Createtime" label="签订时间" width="200"></el-table-column>
          <el-table-column prop="YiFaHuo" label="已发货数量" width="100"></el-table-column>
          <el-table-column prop="WeiFaHuo" label="未发货数量" width="100"></el-table-column>
          <el-table-column prop="operation" label="操作" width="100" fixed="right">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickFaHuo(scope.row)">发货</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 发货 start -->
        <el-dialog title="发货" :visible.sync="dialogFaHuo" width="600px">
          <el-form :model="modelFaHuo" ref="addMechanismRef" label-width="150px">
            <el-form-item label="快递号" class="addAdminForm">
              <el-input v-model="modelFaHuo.trackingnumber" placeholder="请输入快递号"></el-input>
            </el-form-item>
            <el-form-item label="发货数量" class="addAdminForm">
              <el-input v-model="modelFaHuo.num" placeholder="请输入本次发货数量"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="apiAddErp6SaleShip">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 发货 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel,
  },
  name: 'MyErp6SaleCollection',
  data () {
    return {
      activeName: 'first',
      ProjectNameList:[],
      keywords: {
        begintime: '',
        endtime: '',
        orderid: '',
        projectcode: ''
      },
      modelFaHuo: {
        orderid: '',
        projectcode: '',
        trackingnumber: '',
        num: '0'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogFaHuo: false
    }
  },
  mounted () {
    this.apiGetErp6ProjectNameList()
    this.apiGetErp6SaleShipNum()
    this.apiGetErp6SaleShipList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp6SaleShipNum()
      this.apiGetErp6SaleShipList()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportErp6SaleShip(url)
    },
    clickFaHuo (row) {
      this.dialogFaHuo = true
      this.modelFaHuo.orderid = row.Orderid
      this.modelFaHuo.projectcode = row.Projectcode
      this.modelFaHuo.num = 0
    },
    clickReturn () {
      this.activeName = 'first'
    },
    clickexcel () {
      this.apiExcelErp6SaleShip()
    },
    clickSearch () {
      this.selectedPageNo = 1
      this.apiGetErp6SaleShipNum()
      this.apiGetErp6SaleShipList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp6SaleShipList()
    },
    //为下拉框获取数据源-项目名称
    apiGetErp6ProjectNameList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: '',
        code: '',
        classification: ''
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6ProjectNameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.ProjectNameList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetErp6SaleShipNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        orderid: that.keywords.orderid,
        projectcode: that.keywords.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleShipNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetErp6SaleShipList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        orderid: that.keywords.orderid,
        projectcode: that.keywords.projectcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleShipList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddErp6SaleShip: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.modelFaHuo.orderid,
        projectcode: that.modelFaHuo.projectcode,
        trackingnumber: that.modelFaHuo.trackingnumber,
        num: that.modelFaHuo.num
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddErp6SaleShip, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetErp6SaleShipNum()
            that.apiGetErp6SaleShipList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelErp6SaleShip: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErp6SaleShip, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportErp6SaleShip: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportErp6SaleShip, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetErp6ProjectNameList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.warntitle {
  margin-left: 65px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(127, 124, 126);
}

.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}

</style>
